import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/recommendation`;

export class Recommendation {
  static async fetchAll(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async fetchStateCounts(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/statecounts`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async exportRecommendations(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/export`, {
        headers: Contexture.getHeaders(profileId),
        params,
        responseType: 'blob',
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async initiateLiftReport(params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/liftReport`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.status;
    } catch (err) {
      throw err;
    }
  }

  static async getLiftReportStatus(handle, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/liftReport/${handle}/status`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getLiftReportResult(handle, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/liftReport/${handle}/result`,
        {
          headers: Contexture.getHeaders(profileId),
          responseType: 'blob',
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async initiateMoreLikeThis(data, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.post(`${BASE_URL}/moreLikeThis`, data, {
        headers: {
          ...Contexture.getHeaders(profileId),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getMoreLikeThisStatus(handle, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/moreLikeThis/${handle}/status`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getMoreLikeThisResult(handle, params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(
        `${BASE_URL}/moreLikeThis/${handle}/result`,
        {
          headers: Contexture.getHeaders(profileId),
          params,
        }
      );

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
